export enum DidoDocumentenControlColumn {
    Spinner,
    Zichtbaar,
    Bestandsnaam,
    Onderwerp,
    DocumenttypeCode,
    DocumenttypeNaam,
    DocumenttypeOmschrijving,
    Documentnummer,
    AangemaaktDatum,
    Klanten,
    Dossiers,
    AangemaaktDoor,
    GewijzigdDoor,
    PartijKlantNummers,
    DossiersVersies,
    IsUitgechecktDoor,
    IsUitgechecktDatum,
    Taken,
    Status,
    Oorsprong,
    GewijzigdDatum
}
